import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './select.module.scss';

class Select extends Component {
  constructor(props) {
    super(props);

    this.state = { isOpen: false };
    this.handleDropdownClick = this.handleDropdownClick.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleDropdownClick() {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  }

  handleClickOutside(event) {
    const { isOpen } = this.state;
    if (isOpen) {
      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        this.setState({ isOpen: false });
      }
    }
  }

  render() {
    const { isOpen } = this.state;
    const { value, options, onChange, minWidth, myForms, dataCount, customStyles } = this.props;

    let cls = `${styles.select} ${customStyles} `;

    if (isOpen) cls += `${styles.active} `;
    if (minWidth) cls += `${styles.minWidth}`;
    return (
      <div
        role="button"
        tabIndex="0"
        className={cls}
        onClick={this.handleDropdownClick}
        onKeyPress={this.handleDropdownClick}
        ref={this.setWrapperRef}
      >
        <div className={styles.selected}>
          {value && value?.color && (
            <span style={{ backgroundColor: value.color }} />
          )}
          {(value && value.name) || value?.title}
          {' '} {myForms && dataCount ? `(${dataCount})` : ''}
        </div>

        {isOpen && (
          <div className={styles.dropdown}>
            {options.map(option => (
              <div
                role="button"
                tabIndex="0"
                className={styles.option}
                onClick={(e) => {
                  onChange(option);
                  this.setState({ isOpen: false });
                  e.stopPropagation();
                }}
                onKeyPress={(e) => {
                  onChange(option);
                  this.setState({ isOpen: false });
                  e.stopPropagation();
                }}
                key={option?.key}
              >
                {option?.name}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default Select;

Select.propTypes = {
  value: PropTypes.shape({}).isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChange: PropTypes.func.isRequired
};
